import { Theme } from "@mui/material";
import { colors } from "../../theme/colors";

export const startButton = ({ breakpoints }: Theme) => ({
  color: "white",
  backgroundColor: colors.light_black,
  "&:hover": {
    backgroundColor: colors.light_black,
  },
  m: 4,
  pr: 2,
  pl: 2,
  height: "50px",
  fontWeight: "500",
  fontSize: "18px",
});

export const scannerBox = ({ breakpoints }: Theme) => ({
  position: "relative",
  "&::after": {
    content: '" "',
    width: "80%",
    height: "3px",
    backgroundColor: "red",
    position: "absolute",
    top: "50%",
    left: "10%",
    margin: "0px",
    animationName: "barcode-line-animation",
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationDuration: "1.5s",
    animationTimingFunction: "ease-in-out",
  },
});
